import { observer } from 'mobx-react-lite'
import { PromptFieldText } from 'entities/Chatbot/utils/constants'
import { EnhancePrompt } from 'entities/AIAgent/actions/enhancePrompt/EnhancePrompt'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { requestTextingAgentEnhance } from 'entities/AIAgent/Texting/helpers/requestTextingAgentEnhance'
import { PromptField } from 'pages/chatbot/ui/PromptFields/PromptField'
import { useChatbotContext } from 'pages/chatbot/context'

export const PointInstructions = observer(() => {
  const {
    errors,
    model: { settings, getEnhancePromptData },
    id,
  } = useChatbotContext()
  const entities = useEntitiesContext()
  const { instructions, setInstruction, resetInstructions } = settings
  const promptData = getEnhancePromptData(instructions, id ?? 0)
  const instructionsError = errors.getError('settings.instructions.value') ?? ''

  const removeError = () => errors.removeError('settings.instructions')
  const setError = (error: string) => {
    errors.setError('settings.instructions', error)
  }

  return (
    <PromptField
      limit={7000}
      value={instructions}
      error={instructionsError}
      onChange={(value) => setInstruction(value, removeError)}
      resetField={() => resetInstructions(removeError)}
      maxHeight={384}
      questionTooltipProps={{
        label: PromptFieldText.instructions.tooltipLabel,
        breakWord: true,
      }}
      {...PromptFieldText.instructions}
      rightTopAction={
        <EnhancePrompt
          prompt={instructions}
          onAcceptPrompt={(value) => setInstruction(value, removeError)}
          setError={setError}
          requestEnhance={requestTextingAgentEnhance(entities, promptData)}
        />
      }
    />
  )
})
